import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const MestreObras = () => {
  const wpp = generateWhatsAppLink('mestre', 'mestre-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Mestres de Obras | Sustenta LED</title>
        <meta name="description" content="LED para mestres de obras: produtos práticos e eficientes. Somos atacadistas e distribuidores com entrega ágil e suporte." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Mestres de Obras</h1>
              <p>Fornecemos LED para mestres de obras com produtos práticos, eficientes e duráveis. Somos atacadistas e distribuidores com estoque e entrega ágil.</p>
              <p>Indicamos soluções para áreas internas e externas, com foco em rapidez e segurança na instalação.</p>
              <p>Peça sua cotação e receba atendimento especializado para sua obra.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_como_trabalhamos.jpg" alt="LED para Mestres de Obras - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default MestreObras;
